import { useTranslation } from "react-i18next";
import i18n, { translate as tr } from "../../i18n";
import React, { lazy, Suspense, useState } from "react";
import Sidebar from "../common/sidebar";
import TagModal from "../tag/TagModal";
import Footer from "../common/footer";
import "../../assets/css/project-chart.css";

const TagList = lazy(() => import("../tag/TagList"));

const TagPageSkeleton = () => (
  <div className="content-wrap" id="wrapper" aria-hidden="true">
    <div className="main">
      <div className="proj-table-wrap">
        <div className="proj-row proj-row--header">
          <div className="proj-cell proj-cell--name">
            <span className="sk-bar" style={{ width: 110, height: 14, borderRadius: 999, display: "inline-block" }} />
          </div>
          <div className="proj-cell proj-cell--actions" />
        </div>

        {Array.from({ length: 6 }).map((_, index) => (
          <div className="proj-row proj-row--data cl-row-skeleton" key={`tag-page-skeleton-${index}`}>
            <div className="proj-cell proj-cell--name" style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <span className="sk-bar cl-skeleton-badge" />
              <span className="sk-bar cl-skeleton-line cl-skeleton-line--title" />
            </div>
            <div className="tag-row-actions" style={{ gap: 8 }}>
              <span className="sk-bar cl-skeleton-actions" />
              <span className="sk-bar cl-skeleton-actions" />
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default function Tag() {
  useTranslation();
  const [open, setOpen]       = useState(false);
  const [reload, setReload]   = useState(0);
  const [tagTerm, setTagTerm] = useState("");

  const doReload = () => setReload(r => r + 1);

  return (
    <>
      <Sidebar />

      {/* ── Header bar (matches Projects) ── */}
      <div className="header">
        <div className="container-fluid">
          <div className="row" style={{ flexDirection: "column" }}>

            <div className="dash-page-header">
              <div className="dash-page-title">
                <h1>{tr("Tags")}</h1>
                <p>{tr("Create and manage labels that make reports, filters, and time entries easier to organize.")}</p>
              </div>
              <div className="reports-right-item-cont tags-right-header-item">
                <div className="create-new-tag-btn">
                  <button id="add-new-button" onClick={() => setOpen(true)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                      <path fill="#ffffff" fillRule="evenodd"
                        d="M9 9V5.002a.999.999 0 1 1 2 0V9h3.998a.999.999 0 1 1 0 2H11v3.998a.999.999 0 1 1-2 0V11H5.002a.999.999 0 1 1 0-2H9z"/>
                    </svg>
                    <span>{tr("New Tag")}</span>
                  </button>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* ── Tag list ── */}
      <Suspense fallback={<TagPageSkeleton />}>
        <TagList
          reload={reload}
          tagTerm={tagTerm}
          onTagTermChange={(value) => {
            setTagTerm(value);
            doReload();
          }}
        />
      </Suspense>

      {open && (
        <TagModal
          show={open}
          handleClose={() => setOpen(false)}
          reloadList={doReload}
          data=""
        />
      )}

      <Footer />
    </>
  );
}
